export default __webpack_public_path__ + "static/media/glowing smoke_VP9.055a0e8c.webm";